import { CopyRenderer } from '@sleepstation/components-markdown-renderer'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import BeliefsList from './BeliefsList'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({
  spacing: LAYOUT_SPACING.MEDIUM,
  'data-cy': `beliefs-section`,
})``

// -----------------------------------------------------------------------------
// Exports
// -----------------------------------------------------------------------------

const Beliefs = ({ title, beliefs }) => {
  if (!beliefs || beliefs.length === 0) {
    return null
  }

  return (
    <Layout>
      <CopyRenderer htmlAst={title} />
      <BeliefsList beliefs={beliefs} />
    </Layout>
  )
}

Beliefs.propTypes = {
  title: PropTypes.object.isRequired,
  beliefs: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default Beliefs
